import React from 'react';
import { Button } from '@mui/material';
import { BugReport } from '@mui/icons-material';

// Only these aliases can see the debug view toggle
const ALLOWED_ALIASES = ['sttanksa'];

interface DebugViewToggleProps {
  userAlias: string;
  showManagerView: boolean;
  onToggle: () => void;
}

/**
 * Debug-only button that lets specific users flip between the IC and manager
 * views. This is a UI-only toggle: all data access is still enforced by the
 * backend (manager-only endpoints validate the JWT isManager claim and
 * manager/report relationships server-side).
 */
const DebugViewToggle: React.FC<DebugViewToggleProps> = ({ userAlias, showManagerView, onToggle }) => {
  if (!ALLOWED_ALIASES.includes(userAlias)) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      color="warning"
      size="small"
      startIcon={<BugReport />}
      onClick={onToggle}
      sx={{ borderStyle: 'dashed', textTransform: 'none' }}
    >
      Debug: Switch to {showManagerView ? 'IC' : 'Manager'} view
    </Button>
  );
};

export default DebugViewToggle;
